import { Box, Button, Callout, Flex ,Text} from '@radix-ui/themes';
import { QueryStatus } from 'react-query';
import SkeletonLoader from './SkeletonLoader';
import { AvatarIcon, CircleBackslashIcon } from '@radix-ui/react-icons';
interface IListsProps {
    status: QueryStatus;
    TableComponent: any
    handleClickCreate?: any
    handleClickBack?: any
}
export const Lists = ({ status, TableComponent,handleClickCreate, handleClickBack }: IListsProps) => {


    switch (status) {
        case 'error':
            return <>
            <Callout.Root color="red">
                {/* <Callout.Icon /> */}
                <Text>Erro ao carregar os dados. Por favor, tente novamente.</Text>
            </Callout.Root>
            </>
            
        case 'idle':
            return <>
                <Callout.Root color="gray">
                    {/* <Callout.Icon /> */}
                    <Text>Nenhuma ação em andamento.</Text>
                </Callout.Root>
            </>
        case 'loading':
            return <SkeletonLoader />
        case 'success': return (
            <Flex direction='column' gap='3'>
                <Flex gap='3'>
                {handleClickCreate  && typeof handleClickCreate ==='function'? <>
                    <Box>
                        <Button variant="surface" onClick={handleClickCreate}>
                            <AvatarIcon /> Registar
                        </Button>
                    </Box>
                </> : <></>}
                {handleClickBack  && typeof handleClickBack ==='function'? <>
                    <Box>
                        <Button color='red' variant="surface" onClick={handleClickBack}>
                            <CircleBackslashIcon /> Cancelar
                        </Button>
                    </Box>
                </> : <></>}

                </Flex>
                {TableComponent()}
            </Flex>

        )
        default:
            return null;
    }

}